import {handleParam} from "./paramsHandler";
import {setParamInSession} from "./paramsHandler";

export const IS_QA_KEY = "isqa";

export function handleIsqa() {
    const method = (paramKey, paramFromUrl) => {
        console.log("isqa will be set in session storage.");
        setParamInSession(paramKey, paramFromUrl);
    }

    return handleParam(IS_QA_KEY, method, {});
}